import { render, staticRenderFns } from "./MediaPhotosRenderer.vue?vue&type=template&id=056da223"
import script from "./MediaPhotosRenderer.vue?vue&type=script&lang=js"
export * from "./MediaPhotosRenderer.vue?vue&type=script&lang=js"
import style0 from "./MediaPhotosRenderer.vue?vue&type=style&index=0&id=056da223&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports